export default {
  getList(state) {
    return state.list;
  },

  getPageInfo(state) {
    return state.pageInfo;
  },
  getCondition:({condition}) => condition
};
